export enum StructureTypeEnum{
    CLASS,
    ENUM
}